import { Request } from '../lib';

export default {
  list: (data: object) => {
    return Request.get('/subscriptions/dashboard/', data)
  },
  byId: (id: number) => {
    return Request.get(`/subscriptions/dashboard/${id}/`)
  },
  update: (id: number, data: object) => {
    return Request.patch(`/subscriptions/dashboard/${id}/`, data)
  },
  create: (data: object) => {
    return Request.post(`/subscriptions/dashboard/`, data)
  },
  delete: (id: number) => {
    return Request.delete(`/subscriptions/dashboard/${id}/`)
  }
}
